export const Types = {
    ONE : "ONE",
    TWO : "TWO",
    THREE : "THREE",
    FOUR: "FOUR"
}



// WEBPACK FOOTER //
// ./src/Services/Types/index.js